package adapters

import io.ktor.client.*
import io.ktor.client.call.*
import io.ktor.client.plugins.*
import io.ktor.client.plugins.auth.*
import io.ktor.client.plugins.auth.providers.*
import io.ktor.client.plugins.contentnegotiation.*
import io.ktor.client.plugins.websocket.*
import io.ktor.client.request.*
import io.ktor.serialization.kotlinx.json.*
import kotlinx.serialization.ExperimentalSerializationApi
import kotlinx.serialization.MissingFieldException
import ru.malygin.myConst.*
import ru.malygin.urls.UrlHandler
import utils.logger.log


@OptIn(ExperimentalSerializationApi::class)
class Api (
    private val urlHandler: UrlHandler = UrlHandler(),
)
{
    private val client = HttpClient(

    ){
        install(ContentNegotiation){
            json()
        }
        install(Auth){
            bearer {
                loadTokens {//bearer token for admin only
                    BearerTokens(adminToken.first(), null)
                }
            }
        }
        HttpResponseValidator{
            handleResponseExceptionWithRequest { cause, request ->
                when (val ee = cause as? Exception) {
                    is MissingFieldException -> {
                        throw Exception(cause.message+" _1_")
                    }
                    is ClientRequestException -> {
                        throw Exception(cause.message+" _2_")
                    }
                    is Exception -> {
//                        log.i(cause.message+" _0_")
//                        val mes = "Ошибка сервера"
                        throw Exception(cause.message+" _0_")
                    }
                    else -> {
                        //return this with _cause null_ when _server down_ ERROR=[net::ERR_CONNECTION_REFUSED]
                        //от 13.11.2024 он перехватывает все ошибки net::ERR_...
                        val mes = "Ошибка сервера"
                        val code = ErrorCode.SERVER_ERROR
                        throw Exception(code.toString()/*cause.message+" _3_ $ee"*/)
                    }
                }
            }
        }
    }

    private val queryToken = urlHandler.queryToken
    private val queryGroupName = urlHandler.queryGroupName
    private val queryCategory = urlHandler.queryCategory

    private fun checkStatus(
        statusCode: Int
    ):ErrorCode?{
        return when(statusCode){
            401 -> {
//                "Неверный токен"
                ErrorCode.WRONG_TOKEN_ERROR
            }
            404 -> {
//                "Запрашиваемый ресурс не найден"
                ErrorCode.NOT_FOUND_ERROR
            }
            in 200..299 -> {
                null
            }
            else -> {
//                "Неизвестная ошибка"
                ErrorCode.UNKNOWN_ERROR
            }
        }
    }


    suspend fun getMainList(
        groupName:String? = null,
        category: SelectedCategory = SelectedCategory.NONE
    ):ApiReturns {
        val url = urlHandler.getUrlDataByName()

        return try {
            val resp = client
                .get(url.urlOpen) {
                    parameter(
                        queryGroupName, groupName
                    )
                    parameter(
                        queryCategory, category
                    )
                }

            log.i(resp.body<String>().take(50))

            checkStatus(resp.status.value)?.let {
                ApiReturns.Error(
                    code = it,
                    errorMessage = it.message
                )
            } ?: run {
                resp.body<String>().toApiReturnsOr()
            }

        }catch (e:Exception){
            log.e(e)
            val errorIs = e.message?.toErrorCode() ?: ErrorCode.UNKNOWN_ERROR
            ApiReturns.Error(
                code = errorIs,
                errorMessage = "${e.message}"
            )
        }
    }

    suspend fun getScheduleChangeList():ApiReturns{
        val url = urlHandler.getScheduleChangeList()

        return try {
            val resp = client
                .get(url.urlOpen){}
            log.i(resp.body<String>().take(10))

            checkStatus(resp.status.value)?.let {
                ApiReturns.Error(
                    code = it,
                    errorMessage = it.message
                )
            } ?: run {
                resp.body<String>().toApiReturnsOr()
            }

        }catch (e:Exception){
            log.e(e)
            val errorIs = e.message?.toErrorCode() ?: ErrorCode.UNKNOWN_ERROR
            ApiReturns.Error(
                code = errorIs,
                errorMessage = "${e.message}"
            )
        }
    }

    suspend fun getFindTeacherData(): ApiReturns{
        val url = urlHandler.getUrlFindTeacherData()

        return try {
            val resp = client
                .get(url.urlOpen){}
            log.i(resp.body<String>().take(10))

            checkStatus(resp.status.value)?.let {
                ApiReturns.Error(
                    code = it,
                    errorMessage = it.message
                )
            } ?: run {
                resp.body<String>().toApiReturnsOr()
            }
        }catch (e:Exception){
            log.e(e)
            val errorIs = e.message?.toErrorCode() ?: ErrorCode.UNKNOWN_ERROR
            ApiReturns.Error(
                code = errorIs,
                errorMessage = "${e.message}"
            )
        }
    }
}
